import failIcon from 'static/images/deposit/fail.png';
import ongoingIcon from 'static/images/deposit/ongoing.png';
import pendingIcon from 'static/images/deposit/pending.png';
import stopedIcon from 'static/images/deposit/stoped.png';
import successIcon from 'static/images/deposit/success.png';

export const RecurringScheduleStatus = {
    NEW: { icon: pendingIcon, text: __('已提交'), color: '#ff6825' },
    BANK_PROCESSING: { icon: pendingIcon, text: __('已提交'), color: '#ff6825' },
    BANK_PROCESS_SUCC: { icon: successIcon, text: __('申请成功'), color: '#07b360' },
    BANK_PROCESS_FAIL: { icon: pendingIcon, text: __('银行处理中'), color: '#ff6825' },
    REFUSE: { icon: failIcon, text: __('失败'), color: '#fd4e50' },
    RUNNING: { icon: ongoingIcon, text: __('进行中'), color: '#07b360' },
    TERMINATED: { icon: stopedIcon, text: __('已终止'), color: '#fd4e50' },
    STOP: { icon: stopedIcon, text: __('已暂停'), color: '#fd4e50' }
};
